import { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';

import NavLinkExt from './NavLinkExt';
import { UserContext } from './UserProvider';

const Navbar = ({signoutPath}) => {
    const location = useLocation();
    const { user, containerPath, appList } = useContext(UserContext);
    const [menuOpen, setMenuOpen] = useState(false);

    const fullPath = (...props) => `/${Object.values(props).join('/')}`;

    const openMenu = () => {
        setMenuOpen(isOpen => !isOpen);
    }
    // mobile
    if (window.innerWidth < 640) {
        return (
            <>        
                {menuOpen &&
                    <div className="bg-utrgv-orange rounded-xl my-1 p-4 flex flex-col space-y-3">
                        {appList.map(({label, path}, i) =>

                            <NavLinkExt
                                label={label}
                                path={path}
                                key={path}
                                external={!path.startsWith(fullPath(...containerPath))}
                                className='text-white px-4 py-2 mx-2 leading-none border-l-4'
                                activeClass='border-utrgv-blue'
                                inactiveClass='border-transparent'
                                onClick={() => setMenuOpen(false)} />
                        )}

                        <NavLinkExt
                            label='Sign Out'
                            path={signoutPath}
                            key={signoutPath}
                            className='text-white border rounded border-white px-4 py-2 m-2 leading-none text-center' />
                    </div>
                }
                <nav className="flex flex-row justify-between items-center bg-utrgv-orange p-3"
                     role="navigation"
                     onClick={openMenu}>

                    <div className="flex flex-row">
                        <div className="h-auto py-1 text-white">{'{ CS }'}</div>
                        <div className="h-auto py-1 ml-3 text-white">{appList.find(({path}) => location.pathname.startsWith(path))?.label}</div>
                    </div>
                    <div className="text-xl h-auto px-1">
                    <svg viewBox="0 0 24 24" width="24" height="24" fill="white">
                        {menuOpen ?
                        <>
                            <line x1="4" y1="4" x2="21" y2="20" stroke="white" strokeWidth="3" />
                            <line x1="4" y1="20" x2="21" y2="4" stroke="white" strokeWidth="3" />
                        </>
                        :
                        <>
                            <rect y="5"  x="2" width="21" height="2" rx="0"></rect>
                            <rect y="11" x="2" width="21" height="2" rx="0"></rect>
                            <rect y="17" x="2" width="21" height="2" rx="0"></rect>
                        </>}
                    </svg>
                    </div>
                </nav>
            </>
        )
    }

    // computer
    return (
        <nav className="flex flex-row justify-between bg-utrgv-orange md:tracking-wide"
             role="navigation">

            <div className="inline-block ml-2 ">
            {appList.map(({label, path, home}, i) =>
                home 
                ?
                // display username for home path
                <NavLinkExt
                    label={`${user.first_name} ${user.last_name} @ CS`}
                    path={path}
                    key={path}
                    external={!path.startsWith(fullPath(...containerPath))}
                    className='inline-block text-white border rounded border-white px-4 py-2 m-2 leading-none'
                    activeClass='bg-utrgv-blue'
                    inactiveClass='hover:bg-utrgv-blue active:bg-utrgv-lightgray'></NavLinkExt>
                :
                // non-home links
                <NavLinkExt
                    label={label}
                    path={path}
                    key={path}
                    external={!path.startsWith(fullPath(...containerPath))}
                    className='text-white ml-2 p-2 border-b-4'
                    activeClass='border-utrgv-blue'
                    inactiveClass='border-transparent hover:border-utrgv-blue active:border-utrgv-lightgray'></NavLinkExt>
            )}
            </div>

            {/* // signout at end */}
            <NavLinkExt
                label='Sign Out'
                path={signoutPath}
                key={signoutPath}
                className='text-white border rounded border-white px-4 py-2 m-2 leading-none text-center
                           hover:bg-utrgv-blue active:bg-utrgv-lightgray' />
        </nav>
    );
}

export default Navbar;